import { create } from 'zustand';

const useWidgetsStore = create((set) => ({
  // State
  widgets: [],
  widgetLayouts: [],
  isLoading: false,
  error: null,

  // Actions
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Fetch all widgets
  fetchWidgets: async (accessToken) => {
    set({ isLoading: true, error: null });

    try {
      const response = await fetch('/api/widgets', {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch widgets');
      }

      set({
        widgets: data.widgets || [],
        widgetLayouts: data.widget_layouts || [],
        isLoading: false,
      });

      return { success: true, widgets: data.widgets, widgetLayouts: data.widget_layouts };
    } catch (error) {
      set({
        isLoading: false,
        error: error.message,
      });
      return { success: false, error: error.message };
    }
  },

  // Update widget
  updateWidget: async (id, updates, accessToken) => {
    set({ error: null });

    try {
      const response = await fetch(`/api/widgets/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updates),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to update widget');
      }

      // Update widget in list
      set((state) => ({
        widgets: state.widgets.map((w) =>
          w.id === id ? data.widget : w
        ),
      }));

      return { success: true, widget: data.widget };
    } catch (error) {
      set({ error: error.message });
      return { success: false, error: error.message };
    }
  },
}));

export { useWidgetsStore };
